import React from "react";
import styled from "@emotion/styled";
import MemLogomark from "@/assets/images/mem-logomark.svg";
import { MDSSessionNotificationContent } from "@/mds/components/sessions/session-notification";
import { useMDSSession } from "@/mds/components/sessions/session-context";

type Props = {};

export const MDSSessionNotificationView: React.FC<Props> = () => {
  const { internalSessionEvents } = useMDSSession();
  return (
    <NotificationContainer>
      <img src={MemLogomark} alt="Mem logo" style={{ width: 22, height: 22, display: "block" }} />
      <MDSSessionNotificationContent sessionEvents={internalSessionEvents} />
    </NotificationContainer>
  );
};

const NotificationContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  cursor: pointer;
  gap: ${({ theme }) => theme.spacing.sm};
  padding: ${({ theme }) => theme.spacing.lg};
  padding-bottom: ${({ theme }) => theme.spacing.md};
`;
